import React, { useEffect } from 'react';

import './ExplanationBox.css';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

export const ExplanationBox = ({ open, handleClose, type }) => {
  useEffect(() => {}, []);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    maxWidth: 800,
    minWidth: 600,
    transform: 'translate(-50%, -50%)',
    width: '60vw',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <div className='explanation-modal-container'>
          <div className='explanation-modal-title'>
            {type === 'source'
              ? 'How do we characterize the source?'
              : 'How do we calculate the stance?'}
          </div>
          {type === 'source' ? (
            <>
              <div>
                In order to rate the political orientation of the media, an
                opinion poll was conducted among a group of experts, journalists
                and sociologists, in each country. The average of the ratings
                given by these experts on a seven-point ordinal scale ranging
                from extreme left to extreme right was taken as the definitive
                value. In addition, the media outlet in question was consulted,
                and its own response was taken into account when it replied.
              </div>
              <div className='explanation-modal-separator' />
              <div className='explanation-modal-footer'>
                If you have any comments regarding your own views on this
                rating, please send your email{' '}
                <a href='mailto:berta.chulvi@upv.es'>here</a>.
              </div>
            </>
          ) : (
            <>
              <div>
                We calculate news stances from two different perspectives:
                <br /> 1) the point of view of the general population (if 'no
                opinion' is selected); and
                <br /> 2) personalized user view (otherwise).
                <br />
                <br /> Both approaches are powered by state-of-the-art large
                language models utilized in zero-shot mode. The first approach
                is based on the GPT-3.5-Turbo model and prompt engineering,
                while the second is based on entailment and uses the BART model.
                However, these models are not perfect, so the stance calculation
                for some articles may have some errors.
              </div>
            </>
          )}
        </div>
      </Box>
    </Modal>
  );
};
